import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { BaseService } from '../../../shared-service/base.service'
import { OverviewService } from '../overview.service';
import { SharingPanelService } from '../../../shared-service/sharing-panel-service';
//import { SharingPanelComponent } from '../../../shared-components/sharing-panel/sharing-panel.component';
import { WindowRef } from '../../../shared-service/windowRef.service';

declare var $: any;

@Component({
	selector: 'app-settings',
	templateUrl: './settings.component.html',
	styleUrls: ['./settings.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class SettingsComponent implements OnInit {

	userList: Array<any> = [];
	loader: boolean = true;

	@HostListener('window:resize', ['$event'])
	onResize(event:any) {
	  this.updateHeight();
	}

	constructor(public bs: BaseService, private os: OverviewService, private sps: SharingPanelService ,private winRef: WindowRef) {

	}

	ngOnInit() {
		this.GetBlockedUser();
		setTimeout(()=>{
			this.updateHeight();
		},1000);
	}

	updateHeight() {
		let tbody = this.winRef.nativeWindow.document.getElementsByTagName('tbody')[0];
		let parent = this.winRef.nativeWindow.document.getElementsByClassName('setting-panel-inner')[0];
		tbody.style.height = (parent.clientHeight - 250)+'px';
	}

	GetBlockedUser() {
		const params: object =
		{
			'UserID': this.bs.getUserAttr('UserId'),
			'CorporateID': this.bs.getUserAttr('CorporateId'),
			'SearchText': ''

		};
		this.os.getBlockedUserList(params, '****').then((data:any) => {
			this.userList = data['lstUserDetails'];
			this.loader = false;
		}, (data) => {
			this.loader = false;
		});
	}

	search(val: string) {
		this.loader = true;
		const params: object =
		{
			'UserID': this.bs.getUserAttr('UserId'),
			'CorporateID': this.bs.getUserAttr('CorporateId'),
			'SearchText': val

		};

		this.os.getBlockedUserList(params, '****').then((data:any) => {
			this.userList = data['lstUserDetails'];
		
			this.loader = false;
		}, (data) => {
			this.loader = false;
		});
	}
	toggleSelectAllDisplayedUser(check: boolean) {
		$('input:checkbox').prop('checked', check);
	}
	toggleSelectAll(ev: Event|any) {
		console.log(ev.target['checked']);
		if (ev.target['checked']) {
			this.toggleSelectAllDisplayedUser(true);
		} else {
			this.toggleSelectAllDisplayedUser(false);
		}
	}

	/*showHideList() {
		this.sps.updateComponentObj(SharingPanelComponent, { setting: SettingsComponent });
	}

	saveList() {
		let userIds;
		userIds = $('input[name=Users]:checked').map(function () {
			return this.id;
		}).get().join(',');

		if (userIds == '') {
			alert(this.bs.getResource('rbkey_VldtShrUsrMSG'));
			return false;
		}
		else {
			const params: object =
			{
				'UserID': this.bs.getUserAttr('UserId'),
				'CorporateID': this.bs.getUserAttr('CorporateId'),
				'SelectedUserIds': userIds,
			};
			this.os.getUnBlockedSelectedUser(params, "****").then((data) => {
				this.userList = data['lstUserDetails'];

			}, (err) => {
				console.log(err);
			});
		}
		return false;


	}*/
}
